"use strict";

import angular from "angular";

import "../../../shared/components/nu-toast-custom/themes/toast.custom.component-dark.scss";
import "../../../shared/components/nu-toast-custom/themes/toast.custom.component.scss";
import ToastTemplate from "./toast-template.html";
import "./toast-template.scss";

export class toast {
    constructor($mdToast) {
        this.$mdToast = $mdToast;
    }

    /**
     * @public
     * Mostra um toast
     * @param {String} content
     * @param {String} position
     * @param {object} data
     */
    show(content, position, data) {
        this.$mdToast.show(
            this.$mdToast.simple({
                content,
                position: position || "top right",
                ...data
            })
        );
    }

    /**
     * @public
     * Oculta o toast
     */
    hide() {
        this.$mdToast.hide();
    }

    snackbar({
        message,
        buttons,
        cancel,
        after = {},
        extOptions = {},
        extLocals = {}
    }) {
        const options = {
            hideDelay: 0,
            position: "bottom",
            controller: "ToastTemplateCtrl",
            controllerAs: "$ctrl",
            bindToController: true,
            locals: {
                message,
                buttons,
                cancel,
                ...extLocals
            },
            template: ToastTemplate,
            ...extOptions
        };
        this.$mdToast
            .show(options)
            .then((result) => {
                if (after.then) after.then(result);
            })
            .catch((error) => {
                if (after.catch) after.catch(error);
            });
    }
}

angular.module("nucont.shared").service("toast", ["$mdToast", toast]);
